(() => {
  if ( (window).__divanoCartUi) return;
   (window).__divanoCartUi = true;

  const TEST = 'cart_ui_v1';

  function variant() {
    const v =  (window).divanoCartUi;
    return v ? { arm: String(v.arm), forced: v.forced === true } : { arm: 'off', forced: false };
  }

  function publish(name, data) {
    if ( (window).Shopify?.designMode) return;
    let tries = 0;
    (function attempt() {
      const bus =  (window).Shopify?.analytics;
      if (typeof bus?.publish === 'function') {
        try {
          bus.publish(name, data);
        } catch {
        }
        return;
      }
      if (++tries < 20) setTimeout(attempt, 250);
    })();
  }

  function bubbleCount() {
    const text = document.querySelector('#HeaderCartLink .cart-bubble__text-count')?.textContent || '';
    const n = parseInt(text.replace(/\D/g, ''), 10);
    return Number.isFinite(n) ? n : 0;
  }

  if ( (window).divanoCartUi) publish('divano_cart_ui_variant', { test: TEST, ...variant() });

  if (variant().arm === 'drawer') {
    const SECTION = 'divano-cart-ui-drawer';
    let changes = 0;
    const changed = () => {
      changes += 1;
    };
    document.addEventListener('cart:update', changed);
    document.addEventListener('discount:update', changed);
    const fill = async () => {
      if (!document.getElementById(`shopify-section-${SECTION}`)) return;
      const seen = changes;
      try {
        const { sectionRenderer, morphSection } = await import('@theme/section-renderer');
        const url = new URL(location.href);
        url.searchParams.set('divano_drawer_fill', String(Date.now()));
        const html = await sectionRenderer.getSectionHTML(SECTION, false, url);
        if (seen === changes) await morphSection(SECTION, html);
      } catch {
      }
    };
    let settle = () => {};
     (window).divanoCartUiDrawerReady = new Promise((resolve) => {
      settle = resolve;
    });
    const first = () => fill().finally(() => settle());
    if ( (window).__divanoCartUiDrawerPut) first();
    else document.addEventListener('divano:cart-ui-drawer', first, { once: true });
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) fill();
    });
  }

  const CONTROL = 'button[name="checkout"], .additional-checkout-buttons, .accelerated-checkout-block, .shopify-payment-button';

  function expressActionable(event, wrapper) {
    const path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];
    let first = true;
    for (const node of path) {
      if (node === wrapper) return false;
      if (!(node instanceof Element)) continue;
      if (node.hasAttribute('disabled') || node.getAttribute('aria-disabled') === 'true') return false;
      const tag = node.localName;
      if (tag === 'button' || (tag === 'a' && node.hasAttribute('href')) || node.getAttribute('role') === 'button') return true;
      if (tag.includes('-') && (first || /button|wallet/.test(tag))) return true;
      first = false;
    }
    return false;
  }

  function sourceOf(event) {
    const target = event.target;
    if (!(target instanceof Element)) return null;
    const control = target.closest(CONTROL);
    if (!control) return null;
    const inDrawer = Boolean(control.closest('cart-drawer-component'));
    if (control.matches('button[name="checkout"]')) {
      if ( (control).disabled) return null;
      if (control.id === 'CheckoutBar') return 'bar';
      return inDrawer ? 'drawer' : 'page';
    }
    if (!expressActionable(event, control)) return null;
    if (control.matches('.accelerated-checkout-block, .shopify-payment-button')) return 'express_pdp';
    return inDrawer ? 'express_drawer' : 'express_page';
  }

  const lastAt = {};

  function intent(event, trigger) {
    if (trigger === 'pointerup' &&  (event).button) return;
    const source = sourceOf(event);
    if (!source) return;
    const now = performance.now();
    if (now - (lastAt[source] || -Infinity) < 1500) return;
    lastAt[source] = now;
    publish('divano_checkout_intent', {
      test: TEST,
      ...variant(),
      source,
      trigger,
      cart_count: bubbleCount(),
      ms_since_load: Math.round(now),
    });
  }

  document.addEventListener('pointerup', (event) => intent(event, 'pointerup'), { capture: true, passive: true });
  document.addEventListener('click', (event) => intent(event, 'click'), { capture: true, passive: true });

  const cartPath = () => {
    const route = (typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_url) || '/cart';
    return new URL(route, location.origin).pathname.replace(/\/+$/, '') || '/';
  };
  const onCartPage = (location.pathname.replace(/\/+$/, '') || '/') === cartPath();
  if (variant().arm !== 'bar' || !onCartPage) return;

  const style = document.createElement('style');
  style.id = 'divano-checkout-bar-styles';
  style.textContent = `
    .divano-checkout-bar { display: none; }
    @media (max-width: 749px) {
      html[data-divano-checkout-bar='shown'] .divano-checkout-bar:not([hidden]) {
        display: block;
        position: fixed;
        inset-inline: 0;
        inset-block-end: 0;
        z-index: 30;
        padding: 10px 16px calc(10px + env(safe-area-inset-bottom, 0px));
        background: var(--color-background, #fff);
        box-shadow: 0 -4px 16px rgb(0 0 0 / 0.08);
        border-block-start: 1px solid oklch(0.92 0.005 30);
      }
      .divano-checkout-bar__button { width: 100%; min-height: 48px; }
    }
    @media print { .divano-checkout-bar { display: none !important; } }
  `;
  document.head.append(style);

  const bar = document.createElement('div');
  bar.className = 'divano-checkout-bar';
  bar.hidden = true;
  bar.innerHTML =
    '<button type="submit" name="checkout" form="cart-form" id="CheckoutBar" class="button cart__checkout-button divano-checkout-bar__button"></button>';
  const barButton =  (bar.firstElementChild);

  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver(
        (entries) => {
          const entry = entries[entries.length - 1];
          if (!entry) return;
          const below = entry.boundingClientRect.top > 0 && entry.intersectionRatio < 0.6;
          document.documentElement.setAttribute('data-divano-checkout-bar', below ? 'shown' : 'hidden');
        },
        { threshold: [0, 0.6, 1] }
      )
    : null;

  let watched = null;

  function sync() {
    const main =  (document.getElementById('checkout'));
    const form = document.getElementById('cart-form');
    if (!io || !main || !form || main.closest('cart-drawer-component')) {
      bar.hidden = true;
      return;
    }
    if (!bar.isConnected) document.body.append(bar);
    barButton.textContent = (main.textContent || '').trim() || 'Checkout';
    barButton.disabled = main.disabled;
    bar.hidden = main.disabled;
    if (watched !== main) {
      if (watched) io.unobserve(watched);
      io.observe(main);
      watched = main;
    }
  }

  document.addEventListener('cart:update', () => {
    [0, 300, 1000].forEach((ms) => setTimeout(sync, ms));
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();
